import React, { useState } from 'react';
import { UncontrolledPopover, PopoverBody, Alert } from 'reactstrap';
import { Trans, useTranslation } from 'react-i18next';
import './flaggedContent.css';
import EscrowPaymentModal from './escrowPaymentModal';

const FlaggedContent = ({
  id,
  name,
  has_flagged_tracks,
  flagged_tracks,
  is_light_whitelisted,
  escrow_payment_declined,
  status,
  action,
}) => {
  const { t } = useTranslation();
  const [modalOpen, setModalOpen] = useState(false);
  const {forceUpdate, setForceUpdate} = action;

  const toggleModal = () => setModalOpen(!modalOpen);

  const rowId = `row-flagged-content-${id}`;
  const bellColor = is_light_whitelisted ? 'green' : (has_flagged_tracks ? 'red' : 'green');
  const noteColor = is_light_whitelisted ? 'success' : (has_flagged_tracks ? 'danger' : 'success');
  const disabledStatuses = [
    'takedown_request',
    'taken_down',
    're_delivery-delivery',
    'approval',
    'locked',
    'delivering',
  ];
  const isDisabled = disabledStatuses.includes(status);
  const showStatusNote = true;

  const statusNoteText = is_light_whitelisted ?
    ( <><Trans i18nKey="flaggedContent.view.form.message.releaseHasBeenAddedToWhitelist" values={{ releaseName: name}}>Release <strong>{name}</strong> has been added to the whitelist.</Trans></>
    ) : has_flagged_tracks ? (
      <>
        <Trans i18nKey="flaggedContent.view.form.message.releaseHasFlaggedContent" values={{ releaseName: name}}>
          Release <strong>{name}</strong> contains flagged tracks. A fee of <strong>15 €</strong> per flagged track applies to deliver it to <strong>Spotify</strong>.<br/><br/> Click the button below to complete your payment and continue.
        </Trans>
        <br/><br/>
        <center>
          <span
            onClick={toggleModal}
            style={{ 
              textDecoration: 'underline', 
              cursor: 'pointer', 
              color: 'blue', 
              fontWeight: 'bold' 
            }}
          >
            {t("flaggedContent.view.form.button.viewDetails")}
          </span>
        </center>
      </>
    ) : (
      <Trans
        i18nKey="flaggedContent.view.form.message.releaseHasNoFlaggedContent"
        values={{ releaseName: name }}
      >
        Release <strong>{name}</strong> has no flagged tracks and is ready to be delivered to Spotify.
      </Trans>
    );

    return (
    <div>
      <i
        className={"mdi mdi-flag mdi-36px flagged-content-icon" + (showStatusNote ? " flagged-content-avl-icon" : "")}
        id={rowId} 
        aria-hidden="true" 
        style={{ color: bellColor }}
        disabled={!showStatusNote}
      ></i>

      <UncontrolledPopover trigger="legacy" id="flagged-content-popover" placement="bottom" target={rowId} disabled={!showStatusNote}>
        <PopoverBody style={{ padding: "0px" }}>
          <Alert
            color={noteColor}
            style={{ fontSize: "14px", fontWeight: "bolder", margin: "0px", cursor: "pointer" }}
            fade={true}
          >
            {statusNoteText}
          </Alert>
        </PopoverBody>
      </UncontrolledPopover>

      <EscrowPaymentModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        toggleModal={toggleModal}
        id={id}
        name={name}
        flagged_tracks={flagged_tracks}
        escrow_payment_declined={escrow_payment_declined}
        forceUpdate={forceUpdate}
        setForceUpdate={setForceUpdate}
        isDisabled={isDisabled}
      />
    </div>
  );
};

export default FlaggedContent;